import {bindActionCreators} from 'redux';
import {createStructuredSelector} from 'reselect';
// selectors
import {getStage} from '~/selectors/WelcomeSelectors';
// actions
import * as AnalyticsActions from '~/actions/AnalyticsActions';
import * as ProductActions from '~/actions/ProductActions';
import * as DesignActions from '~/actions/DesignActions';
import * as CanvasActions from '~/actions/CanvasActions';
import {fetchSavedDesigns} from '~/actions/AccountActions';
import {prompt} from '~/actions/NotificationActions';

import {isMultiItemEligible} from '~/selectors/ConfigSelectors';
import {getNotification} from '~/selectors/NotificationSelectors';
import {getCurrentDesignName, isDirty} from '~/selectors/DesignSelectors';
import {getSavedDesignsLength} from '~/selectors/AccountSelectors';
import {selectCartItemsCount} from '~/api/designs/cartApi';
import {selectIsCurrentDesignInCart} from '~/slices/cartSlice';

export function select() {
  return createStructuredSelector({
    isMultiItemEligible,
    cartItemCount: selectCartItemsCount,
    designName: getCurrentDesignName,
    isCurrentDesignInCart: selectIsCurrentDesignInCart,
    isDesignDirty: isDirty,
    notification: getNotification,
    savedDesignsLength: getSavedDesignsLength,
    welcome: getStage
  });
}

export function actions(dispatch) {
  return {
    clear: () => {
      dispatch(DesignActions.clearDesignData());
      dispatch(CanvasActions.clear());
      dispatch(ProductActions.reset());
    },
    fetchSavedDesigns: bindActionCreators(fetchSavedDesigns, dispatch),
    analytics: bindActionCreators(AnalyticsActions, dispatch),
    prompt: bindActionCreators(prompt, dispatch)
  };
}
